<template>

  <div>

    <div class="hit-text-left hit-form-group" v-if="$store.getters.user.username">
      <div class="hit-text-right"><a href="#" :style="{'color': survey.colors.accent_color2, 'background-color': survey.colors.accent_color }" class="hit-btn hit-btn-xs hit-btn-default hit-btn-block" v-on:click.prevent="function(){ colorOpen = !colorOpen; }"><hit_icon  :id="'cogwheel'" /> {{ $tc("message.feedback", 2) }}</a></div>

    </div>

    <transition name="fade">
      <div v-if="colorOpen" v-bind:key="colorOpen" class="hit-panel hit-panel-default">
        <div class="hit-panel-body">

          <div class="hit-text-center hit-form-group" v-if="$store.getters.user.username">
            <div class="hit-pull-right">
              <a href="#" v-on:click.prevent="getChangeDesign('next')" class="hit-btn  hit-btn-default"><hit_icon :id="'arrow-right'" /></a>
            </div>
            <div class="hit-pull-left">
            <a href="#" v-on:click.prevent="getChangeDesign('prev')" class="hit-btn  hit-btn-default"><hit_icon :id="'arrow-left'" /></a>
            </div>
            <div class="hit-form-group"><div class="hit-btn hit-btn" style="cursor: default;"><hit_icon :id="'brush'" /> {{ $t("message."+survey.votings.design.toLowerCase()) }}</div></div>
            <div class="hit-text-center"><div class="hit-btn hit-btn-xs" style="cursor: default;"><span class="hit-html-strong">{{ id+1 }}/{{ Object.keys(votings).length }}</span></div></div>
            <div class="hit-clearfix" />
          </div>



        </div>
      </div>
    </transition>

    <transition name="fade">
      <div class="hit-form-group" v-bind:key="votingsKey">
        <hit_votes :survey="survey" :design="survey.votings.design" />
      </div>
    </transition>





  </div>

</template>

<script>

export default{

  props: {survey: Object, callback: Function},

  data () {



    if(typeof this.survey.votings == "undefined")
      this.survey.votings = { design: Object.keys(this.$store.getters.votings)[0] };

    return {
      votingsKey: new Date().getTime(),
      id: 0,
      votings: this.$store.getters.votings,
      colorOpen: false
    }
  },

  methods: {



    getChangeDesign (direction) {
      var votings = this.votings

      var id = 0

      Object.keys(votings).forEach(function (val, index) {
        if (val == this.getDesign().design) {
          this.id = index
          return false
        }
      }.bind(this))

      if (direction == 'prev') {
        this.id = this.id - 1

        if (this.id < 0) { this.id = (Object.keys(votings).length - 1) }
      }
      if (direction == 'next') {
        this.id = this.id + 1

        if (this.id == Object.keys(votings).length) { this.id = 0 }
      }

      this.survey.votings.design = Object.keys(votings)[this.id]

      this.callback(JSON.stringify(this.survey.votings))

      this.votingsKey = new Date().getTime()
    },

    getDesign () {
      return this.survey.votings
    }
  },

  mounted () {
    this.getChangeDesign(false)
  }

}

</script>
